type QueryError = { status?: number | string };

function statusOf(error: unknown): string {
  const status = (error as QueryError | undefined)?.status;
  if (typeof status === 'number') return String(status);
  if (typeof status === 'string') return status;
  return 'Unknown error';
}

export function queryErrorDetail(error: unknown, endpoint: string): string {
  return `${statusOf(error)} from ${endpoint}`;
}
